import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import Seo from "../components/Seo";
import JobCard from "../components/JobCard";

export default function NhsJobs() {
  const [data, setData] = useState({ items: [], total: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/jobs", { params: { source: "nhs", limit: 50 } })
      .then((res) => setData(res.data))
      .catch(() => setData({ items: [], total: 0 }))
      .finally(() => setLoading(false));
  }, []);

  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14" data-testid="nhs-jobs-page">
      <Seo
        title="NHS Jobs in the UK | HiredToday"
        description="Browse live external NHS vacancies across the UK. View the official vacancy and apply directly on NHS Jobs, no account needed."
        path="/jobs/nhs"
        noindex={!loading && data.total === 0}
      />
      <div className="mb-8">
        <h1 className="font-display text-4xl sm:text-5xl tracking-tighter font-black text-zinc-950">NHS jobs in the UK</h1>
        <p className="mt-3 text-zinc-600" data-testid="nhs-jobs-count">
          {loading ? "Searching…" : `${data.total.toLocaleString("en-GB")} live external NHS vacancies`}
        </p>
        <p className="mt-2 text-sm text-zinc-500 max-w-2xl leading-relaxed">
          These vacancies come from the official NHS Jobs service. Each listing shows the accurate summary supplied by
          NHS Jobs; the full description and application are completed on the official NHS site, with no HiredToday
          account required.
        </p>
      </div>

      {loading ? (
        <div className="grid gap-4">
          {[...Array(3)].map((_, i) => (
            <div key={`nhs-skel-${i}`} className="border border-zinc-200 rounded-md p-6 animate-pulse">
              <div className="h-5 bg-zinc-100 rounded w-1/3 mb-3" />
              <div className="h-4 bg-zinc-100 rounded w-1/4" />
            </div>
          ))}
        </div>
      ) : data.items.length === 0 ? (
        <div className="border border-dashed border-zinc-300 rounded-md p-12 text-center" data-testid="nhs-jobs-empty">
          <p className="font-display text-xl font-bold text-zinc-900">No NHS vacancies right now.</p>
          <p className="mt-2 text-sm text-zinc-500">The feed updates daily. Browse all live jobs in the meantime.</p>
          <Link to="/jobs" data-testid="nhs-browse-all"
            className="mt-6 inline-flex items-center gap-2 bg-zinc-950 text-white text-sm font-semibold px-6 py-3 rounded-md hover:bg-zinc-800 transition-colors duration-200">
            Browse all jobs
          </Link>
        </div>
      ) : (
        <div className="grid gap-4" data-testid="nhs-jobs-results">
          {data.items.map((job, i) => <JobCard key={job.id} job={job} index={i} />)}
        </div>
      )}

      <p className="mt-10 text-xs text-zinc-400" data-testid="nhs-jobs-attribution">
        Vacancies from <a href="https://www.jobs.nhs.uk/" target="_blank" rel="noreferrer" className="underline">NHS Jobs</a>.
      </p>
    </main>
  );
}
